import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, of, throwError } from "rxjs";
import { catchError } from "rxjs/operators";

import { ProductFeature } from "./product-feature.models";

@Injectable()
export class ProductFeatureService {
  private http = inject(HttpClient);

  getProductFeatures(): Observable<ProductFeature[]> {
    return this.http.get<ProductFeature[]>("products/features");
  }

  enableProductFeature(id: string): Observable<void> {
    return this.http.put<void>(`products/features/${id}`, null);
  }

  disableProductFeature(id: string): Observable<void> {
    return this.http.delete<void>(`products/features/${id}`).pipe(
      catchError((error: HttpErrorResponse) => {
        // The API returns 404 if the product-feature doesn't exist.
        // Since we were trying to delete it anyway, we don't care,
        // so treat it as success.
        if (error.status === 404) {
          return of(void 0); // return a successful observable with void value
        }
        // otherwise return the error
        return throwError(
          () =>
            new Error(`HTTP error ${error.status}: ${error.message}`, {
              cause: error,
            })
        );
      })
    );
  }
}
